import React, { useState, useEffect, useRef } from "react";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import InnerLoader from "../Loader/InnerLoader";
import { useTranslation } from "react-i18next";
/* ------------------------------- properties ------------------------------- */
// header
// value
// valuePlaceholder
// valueChanged
// valueName

// error
/* --------------------------------- events --------------------------------- */
//saveClicked
//

const EditorActions = ({
	header,
	disabled,
	value,
	valueName,
	valuePlaceholder,
	valueChanged,
	errors,
	active,
	deleteText,
	deleteClicked,
	redoClicked,
	ShowMoreButtons,
	shareClicked,
	shareComments,
	saveClicked,
	customButtonText,
	customButtonIcon,
	customButtonClicked,
	customButtonDisabled,
	deleteDisabled,
	transactionError,
	hasErrors,
	popupActions,
	saving,
	children,
}) => {
	const anchor = useRef(null);
	const popupContent = useRef(null);
	const [show, setShow] = useState(false);

	const { t } = useTranslation("common/editor_actions", { useSuspense: false });

	const handlePopup = (e) => {
		if (popupContent && popupContent.current && anchor && anchor.current && !anchor.current.contains(e.target) && !popupContent.current.contains(e.target)) {
			setShow(false);
		}
	};

	useEffect(() => {
		document.addEventListener("click", handlePopup);

		return () => {
			document.removeEventListener("click", handlePopup);
		};
	}, []);

	const handlePopupActionClick = (e, action) => {
		e.preventDefault();
		setShow(false);
		action.onClick(e);
	};

	return (
		<>
			<div className="px-2 mb-2 border-bottom ">
				<div className="d-flex justify-content-between align-items-center">
					<div className="bold h5 ms-1">{header}</div>

					<div className="d-flex justify-content-center align-items-center">

						{saving && (
							<InnerLoader borderColor="green" />
						)}

						<button title="Save" onClick={saveClicked} type="submit" disabled={active} className="mx-2 my-2 btn btn-primary">
							<i className="fas fa-save"></i>&nbsp;{t("buttons.save")}
						</button>

						{customButtonText && (
							<button title={customButtonText} onClick={customButtonClicked} type="button" disabled={customButtonDisabled} className={`btn btn-primary mx-2 my-2`}>
								<i className={`fas fa-${customButtonIcon}`}></i>&nbsp;
								{customButtonText}
							</button>
						)}

						<Menu onSelect={(e) => e.item.data()} className="no-dropdown-in-menu">
							<MenuItem cssClass="btn btn-secondary px-1" icon="more-horizontal g-0 m-0 ps-2" data={() => { }}>
								{deleteClicked && (
									<MenuItem disabled={deleteDisabled} text={deleteText || t("buttons.delete")} icon="times" data={deleteClicked} />
								)}
								<MenuItem text={t("buttons.revert")} icon="undo" disabled={!hasErrors} data={redoClicked} />
								{!ShowMoreButtons && popupActions && popupActions.map((action) => <MenuItem cssClass="p-1" icon={action.icon} text={action.text} disabled={action.disabled} data={action.onClick} />)}
								{shareClicked !== undefined && <MenuItem cssClass="p-1" icon="share" text={t("buttons.share_link")} data={shareClicked} />}
							</MenuItem>
						</Menu>
					</div>
				</div>
				{/* error section */}
				{errors &&
					errors
						.filter((o) => o)
						.map((err, i) => {
							return (
								<div key={i} className="text-danger anim">
									<i className="mx-1 fas fa-exclamation-circle"></i>
									{err}
								</div>
							);
						})}
				{transactionError &&
					transactionError.map(
						(err, i) =>
							err && (
								<div key={i} className="text-danger">
									&nbsp;
									<i className="fas fa-exclamation-circle text-danger"></i> {err}
								</div>
							)
					)}
			</div>
		</>
	);
};

const PopupAction = ({ children }) => children;
PopupAction.displayName = "PopupAction";
EditorActions.PopupAction = PopupAction;

export default EditorActions;

/* --------------------------------- example -------------------------------- */
{
	/*
<EditorActions
		header={`Attribute ${this.SideData.sysName}`}
		value={this.state.attributeName}
		valuePlaceholder={"Enter Attribute Name"}
		valueName="attributeName"
		valueChanged={this.handleInput}
		errors= {[this.state.nameExists && "Attribute Already Exist" , !this.state.validName && "Empty name not allowed" ]}

		active={this.state.disabled || this.state.showError || this.state.nameExists}
		shareClicked={this.copyAttributeLink}
		deleteClicked={() => { this.Delete(this.SideData.rel_id) }}
		/> 
*/
}
